<template>
  <div class="flex-col">
    <!-- CHECKBOX -->
    <span bottom class="text-xs-center margin-auto primary--text">
      <i aria-hidden="true" class="v-icon material-icons primary--text">
        {{
            inPartListBasket(part) ? 'check_box'
              : 'check_box_outline_blank'
        }}
      </i>
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    selected: {
      type: Boolean,
      required: true
    },
    part: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapState({
      skin: state => state.settings.skin,
      partListBasket: state => state.parts.partListBasket
    })
  },
  methods: {
    inPartListBasket(part) {
      return (this.partListBasket.findIndex(i => i == part)) !== -1
    },
  }
}
</script>